import { Navigate } from "react-router-dom";
import useFundsTransferStore from "../../stores/fundsTransferStore";

export default function FundsTransferFlowGuard({ children }) {
  const isFlowActive = useFundsTransferStore((state) => state.isFlowActive);

  if (!isFlowActive) {
    return <Navigate to="/funds-transfer" replace />;
  }

  return children;
}
